import { UpdateVisibilityResponse } from '@/modules/drive/domain/models/ResponseUpdateVisibility'

import { axios, Response } from '../index'

export interface Body {
  id?: string
  name?: string
  folderVisibility?: string
  parentFolderId?: string
}

const updateFolderGroup = (
  groupId: string,
  folderId: string,
  body: Body
): Response<UpdateVisibilityResponse> => {
  return axios.put(`/v1/group/${groupId}/folders/${folderId}`, body)
}

export default updateFolderGroup
